import React from 'react';
import { FormattedMessage } from 'react-intl';
import DashboardLayout from './../layout/Dashboard';
import {ChangePassword} from "../../components/pages/profile/ChangePassword";
import {EditUserDetails} from "../../components/pages/profile/EditUserDetails";
import { Security } from '../../components/pages/profile/Security';
import { FEATURE_PASSKEY } from '../../config/features';
import { PageHeader, PageWorkspace } from '../../components/layout/Workspace';
import './Profile.scss';

const Profile = (props) => {
  return (
    <DashboardLayout pageTitle={<FormattedMessage id="app.dashboard.page_title"/>} workspace={true} {...props}>
      <PageWorkspace className="profile-workspace">
        <PageHeader title={<FormattedMessage id="components.layout.navbars.profileDropdown.my_profile" />} />
        <div className="profile-grid">
          <EditUserDetails />
          <ChangePassword />
          {FEATURE_PASSKEY && <Security />}
        </div>
      </PageWorkspace>
    </DashboardLayout>
  )
}

export { Profile }
